module.exports = __webpack_public_path__ + "img/Oludiran Akinkunmi_Data Analyst.46c6c9b8.jpg";